import type { URLS } from '@/lib/consts';

/*
 * Extracts only valid service URLs from URLS;
 */
export type ServiceURLs = (typeof URLS.SERVICES)[keyof typeof URLS.SERVICES];

export enum ServiceType {
  ROOT = 'ROOT',
  BUILD = 'BUILD',
  RENOVATE = 'RENOVATE',
}
